import useSelfService from './SelfService';

export default abstract class BaseService {

	protected get self () { return useSelfService().self };

}
